import React, { useEffect } from "react"
import * as styles from "./breadcrumb.module.scss"
import { HeaderMenuFieldsFragment } from "../../../../graphql-types"
import sanitizeHtml from "sanitize-html"
import Chevron from "../../layout/header/side-menu/accordion/chevron"
import { detectWebView } from "../../../utils"

type RenderProps = {
  menuData: HeaderMenuFieldsFragment
  pageTitle: string
  pageSlug?: string
  locale: string
  defaultLocale: string
}

export let pageInfo: {
  parent: string
  selected: string
  parentSlug: string
} = { parent: null, selected: null, parentSlug: null }

const Breadcrumb: React.FC<RenderProps> = ({ menuData, pageTitle, pageSlug, locale, defaultLocale }) => {
  const sanitizedTitle = sanitizeHtml(pageTitle, {
    allowedTags: [],
    allowedAttributes: {},
  })
  const homeLabel = menuData.breadcrumbHomeLabel
  const isWebView = detectWebView()

  const pages: {
    parent: string
    selected: string
    parentSlug: string
  } = { parent: null, selected: null, parentSlug: null }

  const searchInSubMenu = () => {
    menuData.menuSection.forEach(menuSection => {
      menuSection.subMenu.forEach(subMenu => {
        if (subMenu.page && pageSlug === subMenu.page.slug) {
          pages.parent = menuSection.label
          pages.parentSlug = menuSection.page ? menuSection.page.slug : menuSection.externalPage
          pages.selected = subMenu.label
        }
      })
    })
  }

  if (!pages.selected) {
    menuData.menuSection.forEach(menuSection => {
      if (menuSection.page && pageSlug === menuSection.page.slug) {
        pages.selected = menuSection.label
      }
    })
  }
  if (!pages.selected) {
    searchInSubMenu()
  }

  useEffect(() => {
    pageInfo = pages
  }, [])

  return (
    <nav aria-label={menuData.breadcrumbAriaLabel} className={`${styles.accessNav} ${isWebView ? styles.webView : ""}`}>
      <ol className={styles.breadcrumb}>
        <li className={styles.breadcrumbList}>
          <a href={locale === defaultLocale ? "/" : `/${locale}`} className={styles.label}>
            {homeLabel}
          </a>
          <div className={styles.chevronBox}>
            <Chevron aria-hidden={true} className={styles.chevron} />
          </div>
        </li>

        {(pages.parent || pages.selected) && (
          <li className={styles.breadcrumbList}>
            {pages.parent ? (
              <a
                href={locale === defaultLocale ? `/${pages.parentSlug}` : `/${locale}/${pages.parentSlug}`}
                className={styles.label}
              >
                {pages.parent}
              </a>
            ) : (
              <span className={styles.selectedLabel} aria-current="page">
                {pages.selected}
              </span>
            )}
            {pages.parent && (
              <div className={styles.chevronBox}>
                <Chevron aria-hidden={true} className={styles.chevron} />
              </div>
            )}
          </li>
        )}

        {pages.parent && (
          <li>
            <span className={styles.selectedLabel} aria-current="page">
              {pages.selected}
            </span>
          </li>
        )}

        {!pages.parent && !pages.selected && (
          <li>
            <div
              className={styles.selectedLabel}
              aria-current="page"
              dangerouslySetInnerHTML={{ __html: sanitizedTitle }}
            />
          </li>
        )}
      </ol>
    </nav>
  )
}

export default Breadcrumb
